const KEYS_PERMITTED_MATHEMATICAL_EDITOR = [
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '+',
  '-',
  '*',
  '/',
  '',
  'Backspace',
  '(',
  ')',
  ' ',
  '.',
  '%',
  'ArrowLeft',
  'ArrowRight',
  'ArrowUp',
  'ArrowDown',
  'Shift'
]

export default KEYS_PERMITTED_MATHEMATICAL_EDITOR;